export default "__VITE_ASSET__rP$FuK7M__"